import { crv, cva } from '@/styled-system/css';

export const iconRecipe = cva({
  base: {
    display: 'inline-flex',
    flexShrink: '0',
    verticalAlign: '-0.125em', // Magic number, but works with all textStyles
    fill: 'currentcolor',
    width: '1em',
    height: '1em',
  },
  variants: {
    ...crv('size', {
      sm: { width: 'icon.sm', height: 'icon.sm' },
      md: { width: 'icon.md', height: 'icon.md' },
      lg: { width: 'icon.lg', height: 'icon.lg' },
      xl: { width: 'icon.xl', height: 'icon.xl' },
    }),
  },
});
